import { ref } from 'vue'
import { getSiteIsOpen } from '@views/home/media/api'

export default () => {
  const websiteData = ref<any>({})
  getSiteIsOpen().then(res => {
    websiteData.value = res.data || {}
  })
  return {
    websiteData,
  }
}
